import { useCallback, useEffect, useState } from 'react'

/**
 * チュートリアルの終了で、動画窓を自動再生するか。
 *
 * 動画窓（useMissionVideoWidget）は、この値が false -> true に変わったときに
 * 自動再生で作り直す。ページを読み直さずに別の作品でチュートリアルを始め直したとき
 * （startInitialTutorial が true になったとき）は false に戻し、次の終了でもう一度
 * false -> true になるようにする。戻さないと、2 回目以降の終了で自動再生しない
 */
export const useTutorialAutoPlay = (startInitialTutorial: boolean) => {
  const [autoPlay, setAutoPlay] = useState(false)

  useEffect(() => {
    if (startInitialTutorial) setAutoPlay(false)
  }, [startInitialTutorial])

  const handleTutorialEnd = useCallback(() => {
    setAutoPlay(true)
  }, [])

  return { autoPlay, handleTutorialEnd }
}
